/* Holds shared constants used by multiple packages */

/* The common search parameters, used by suds-web and e2e tests. */

export const COMMON_SEARCH_PARAMETERS = {
  t: 'Software%20Docs',
  sort: 'relevancy',
};

export const ROOT_HTML_ZEDS = ['gecko-os', 'wifi', 'rs9116', 'thread'];

// Inpage links will break when we split PDF into chunks
// so we should change all the links into external links during serve phase
// and transform all the links back after merging all the chunks
export const PDF_INPAGE_LINK_PREFIX = 'https://pdf-inpage-link/';
